module.exports = __webpack_public_path__ + "static/sentor-26fcf120696bdfc401e8eb1e95959383.png";